"use client";

import { useEffect, useRef } from "react";

import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { useCustomUmrahFlowPersist } from "@/feature/umrah/custom/request/hooks/use-custom-umrah-flow-persist";
import {
  hydrateCustomUmrahFlowState,
  selectCustomUmrahFlow,
} from "@/feature/umrah/custom/request/state/custom-umrah-flow.slice";

export function SearchServicesBootstrap() {
  const dispatch = useAppDispatch();
  const customUmrahFlow = useAppSelector(selectCustomUmrahFlow);
  const { persistFlowState, restoredState } = useCustomUmrahFlowPersist();
  const hasHydratedPersistedStateRef = useRef(false);

  useEffect(() => {
    dispatch(hydrateCustomUmrahFlowState(restoredState));
    hasHydratedPersistedStateRef.current = true;
  }, [dispatch, restoredState]);

  useEffect(() => {
    if (!hasHydratedPersistedStateRef.current) {
      return;
    }

    persistFlowState(customUmrahFlow);
  }, [customUmrahFlow, persistFlowState]);

  return null;
}



